import React, { useEffect, useState } from "react";
import { FaSliders} from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import "./css/NuevoUsuario.css";

const NuevoUsuario = () => {
  
  return (
    <>
        <Navbar />
        
        <main className="main historico">

        </main>
    </>
  );
};

export default NuevoUsuario;